// extracted by mini-css-extract-plugin
export var audioPlayer = "_tk-0";